<template>
  <div class="datatable">
    <div class="filterer">
      <input type="text" placeholder="filter" v-model="filterstring">
    </div>
    <ul>
      <slot></slot>
    </ul>    
  </div>
</template>

<script>
export default {
  name: 'datatable',
  props: [ 'items' ],
  data(){
    return {
      filterstring: '',
    }
  },
  methods: {
    getItemsLength(){
      return this.items.length // if array
      // if obj, return keys length something
    },
  },
  components: { },
}
</script>

<style lang="scss">
	@import '../styling/global_vars';

	.datatable {
	  ul {
	    li {
	      padding: .75em;
        list-style: none;
        &:nth-child(odd) { background-color: rgba(black,.05); }
	    }
	  }
	}

</style>



// WEBPACK FOOTER //
// Datatable.vue?51c4e56c